import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { CheckAPIName } from '../../constants/Check';
import * as AWSconst from '../../constants/AWS';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import { AwsCredentialIdentity } from '@aws-sdk/types';
import { SignatureV4 } from '@smithy/signature-v4';
import { HttpRequest } from '@smithy/protocol-http';
import { Sha256 } from '@aws-crypto/sha256-browser';
import axios from 'axios';
import {
  BadRequestError,
  InternalServerError,
  NotFoundError,
  UnauthorizedError,
  ConflictError,
} from '../../constants/API';
import { asyncGetSession } from '../Auth/api';
import { RecordedAtNamesList } from '../../constants/Check';
import { AggregateRow } from '../../constants/Analytics';

const urlBuilderGET = (name: CheckAPIName, unique_id: string, year: number, month: number, byYear = false): string => {
  let from_date = '';
  let to_date = '';
  if (byYear) {
    from_date = `${year - 1}-${('0' + month).slice(-2)}-01`;
    to_date = `${year}-${('0' + month).slice(-2)}-${new Date(year, month, 0).getDate()}`;
  } else {
    from_date = `${year}-${('0' + month).slice(-2)}-01`;
    to_date = `${year}-${('0' + month).slice(-2)}-${new Date(year, month, 0).getDate()}`;
  }
  let url = '';
  switch (name) {
    case 'tug':
      url = `/admin/walking/tug/${unique_id}/records/from/${from_date}/to/${to_date}`;
      break;
    case 'cs30':
      url = `/admin/chairstand/${unique_id}/records/from/${from_date}/to/${to_date}`;
      break;
    case 'balance':
      url = `/admin/balance/${unique_id}/records/from/${from_date}/to/${to_date}`;
      break;
    case 'rom':
      url = `/admin/rom/${unique_id}/records/from/${from_date}/to/${to_date}`;
      break;
    case 'ss5':
      url = `/admin/ss5/${unique_id}/records/from/${from_date}/to/${to_date}`;
      break;
    case 'grip_right':
      url = `/admin/physical_record/${unique_id}/records/0/from/${from_date}/to/${to_date}`;
      break;
    case 'grip_left':
      url = `/admin/physical_record/${unique_id}/records/1/from/${from_date}/to/${to_date}`;
      break;
    case 'height':
      url = `/admin/physical_record/${unique_id}/records/2/from/${from_date}/to/${to_date}`;
      break;
    case 'weight':
      url = `/admin/physical_record/${unique_id}/records/3/from/${from_date}/to/${to_date}`;
      break;
    default:
      throw Error(`${name} is not exist`);
  }
  return url;
};

const urlBuilderPOST = (name: CheckAPIName, unique_id: string): string => {
  let url = '';
  switch (name) {
    case 'tug':
      url = `/admin/walking/tug/${unique_id}/records`;
      break;
    case 'cs30':
      url = `/admin/chairstand/${unique_id}/records`;
      break;
    case 'balance':
      url = `/admin/balance/${unique_id}/records`;
      break;
    case 'rom':
      url = `/admin/rom/${unique_id}/records`;
      break;
    case 'ss5':
      url = `/admin/ss5/${unique_id}/records`;
      break;
    case 'grip_right':
      url = `/admin/physical_record/${unique_id}/records/0`;
      break;
    case 'grip_left':
      url = `/admin/physical_record/${unique_id}/records/1`;
      break;
    case 'height':
      url = `/admin/physical_record/${unique_id}/records/2`;
      break;
    case 'weight':
      url = `/admin/physical_record/${unique_id}/records/3`;
      break;
    default:
      throw Error(`${name} is not exist`);
  }
  return url;
};

const urlBuilderPUT = (name: CheckAPIName, unique_id: string, date: string): string => {
  // Do not encode date here - URL constructor handles space encoding and SignatureV4 with
  // uriEscapePath: true handles the rest
  const encodedDate = date;
  let url = '';
  switch (name) {
    case 'tug':
      url = `/admin/walking/tug/${unique_id}/records/${encodedDate}`;
      break;
    case 'cs30':
      url = `/admin/chairstand/${unique_id}/records/${encodedDate}`;
      break;
    case 'balance':
      url = `/admin/balance/${unique_id}/records/${encodedDate}`;
      break;
    case 'rom':
      url = `/admin/rom/${unique_id}/records/${encodedDate}`;
      break;
    case 'ss5':
      url = `/admin/ss5/${unique_id}/records/${encodedDate}`;
      break;
    case 'grip_right':
      url = `/admin/physical_record/${unique_id}/records/0/${encodedDate}`;
      break;
    case 'grip_left':
      url = `/admin/physical_record/${unique_id}/records/1/${encodedDate}`;
      break;
    case 'height':
      url = `/admin/physical_record/${unique_id}/records/2/${encodedDate}`;
      break;
    case 'weight':
      url = `/admin/physical_record/${unique_id}/records/3/${encodedDate}`;
      break;
    default:
      throw Error(`${name} is not exist`);
  }
  return url;
};

const urlBuilderSwapPUT = (name: CheckAPIName, unique_id: string): string => {
  let url = '';
  switch (name) {
    case 'tug':
      url = `/admin/walking/tug/${unique_id}/records`;
      break;
    case 'cs30':
      url = `/admin/chairstand/${unique_id}/records`;
      break;
    case 'balance':
      url = `/admin/balance/${unique_id}/records`;
      break;
    case 'rom':
      url = `/admin/rom/${unique_id}/records`;
      break;
    case 'ss5':
      url = `/admin/ss5/${unique_id}/records`;
      break;
    case 'grip_right':
      url = `/admin/physical_record/${unique_id}/records`;
      break;
    case 'grip_left':
      url = `/admin/physical_record/${unique_id}/records`;
      break;
    case 'height':
      url = `/admin/physical_record/${unique_id}/records`;
      break;
    case 'weight':
      url = `/admin/physical_record/${unique_id}/records`;
      break;
    default:
      throw Error(`${name} is not exist`);
  }
  return url;
};

const urlBuilderDELETE = (name: CheckAPIName, unique_id: string, date: string): string => {
  // Do not encode date here - URL constructor handles space encoding and SignatureV4 with
  // uriEscapePath: true handles the rest
  const encodedDate = date;
  let url = '';
  switch (name) {
    case 'tug':
      url = `/admin/walking/tug/${unique_id}/records/${encodedDate}`;
      break;
    case 'cs30':
      url = `/admin/chairstand/${unique_id}/records/${encodedDate}`;
      break;
    case 'balance':
      url = `/admin/balance/${unique_id}/records/${encodedDate}`;
      break;
    case 'rom':
      url = `/admin/rom/${unique_id}/records/${encodedDate}`;
      break;
    case 'ss5':
      url = `/admin/ss5/${unique_id}/records/${encodedDate}`;
      break;
    case 'grip_right':
      url = `/admin/physical_record/${unique_id}/records/0/${encodedDate}`;
      break;
    case 'grip_left':
      url = `/admin/physical_record/${unique_id}/records/1/${encodedDate}`;
      break;
    case 'height':
      url = `/admin/physical_record/${unique_id}/records/2/${encodedDate}`;
      break;
    case 'weight':
      url = `/admin/physical_record/${unique_id}/records/3/${encodedDate}`;
      break;
    default:
      throw Error(`${name} is not exist`);
  }
  return url;
};

export class CheckAdminClient {
  client: AxiosInstance;
  baseURL: string;

  static async ClientFactory() {
    const user = AWSconst.userPool().getCurrentUser();
    if (!user) {
      throw Error('user not signed in');
    }
    const session = await asyncGetSession(user);

    const region = process.env.REACT_APP_AWS_REGION || '';
    const identityPoolId = process.env.REACT_APP_AWS_IDENTITY_POOL_ID || '';

    // AWS SDK v3: Get credentials from Cognito Identity Pool
    const credentialsProvider = fromCognitoIdentityPool({
      identityPoolId,
      logins: {
        [AWSconst.cognitoIdpURL]: session.getIdToken().getJwtToken(),
      },
      clientConfig: { region },
    });

    const credentials = await credentialsProvider();

    return new CheckAdminClient(credentials, region);
  }

  constructor(credentials: AwsCredentialIdentity, region: string) {
    this.baseURL = process.env.REACT_APP_CHECK_API_URL || '';
    this.client = axios.create({
      baseURL: this.baseURL,
    });

    // Add AWS SigV4 signing interceptor (same approach as BaseAPI.ts DayCareApiIamAuth)
    this.client.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
      // Build full URL the same way Axios does (concatenation, not URL resolution)
      const fullUrl = (config.baseURL || '') + (config.url || '');
      const url = new URL(fullUrl);

      // Add query params from config.params (Axios adds these later, but we need them for signing)
      if (config.params) {
        Object.keys(config.params).forEach(key => {
          const value = config.params[key];
          if (value !== undefined && value !== null) {
            url.searchParams.append(key, String(value));
          }
        });
      }

      const method = config.method?.toUpperCase() || 'GET';

      // For GET/DELETE requests, body should be undefined
      // For POST/PUT, serialize body to JSON string (same as Axios does)
      let body: string | undefined;
      if (method !== 'GET' && method !== 'DELETE' && config.data !== undefined) {
        body = typeof config.data === 'string' ? config.data : JSON.stringify(config.data);
      }

      // Build headers for signing
      // IMPORTANT: 'host' header MUST be included in the signature
      // For POST/PUT, 'content-type' and 'content-length' must also be included
      const headersRecord: Record<string, string> = {
        host: url.hostname,
      };

      // For POST/PUT requests, include content-type and content-length in signature
      if (method === 'POST' || method === 'PUT') {
        const contentType = config.headers?.get('content-type');
        if (contentType && typeof contentType === 'string') {
          headersRecord['content-type'] = contentType;
        }
        // Calculate content-length from body
        if (body !== undefined) {
          headersRecord['content-length'] = String(new TextEncoder().encode(body).length);
        }
      }

      if (config.headers) {
        Object.keys(config.headers).forEach(key => {
          const value = config.headers.get(key);
          if (value && typeof value === 'string') {
            const lowerKey = key.toLowerCase();
            // Only include AWS-specific headers in signature
            if (lowerKey.startsWith('x-amz-')) {
              headersRecord[lowerKey] = value;
            }
          }
        });
      }

      // Build query parameters object for signing
      const queryParams: Record<string, string> = {};
      url.searchParams.forEach((value, key) => {
        queryParams[key] = value;
      });

      // Create HttpRequest for signing
      // Use 'query' property instead of appending to path for proper signature calculation
      const httpRequestOptions: any = {
        method,
        protocol: url.protocol,
        hostname: url.hostname,
        port: url.port ? Number(url.port) : undefined,
        path: url.pathname,
        query: Object.keys(queryParams).length > 0 ? queryParams : undefined,
        headers: headersRecord,
      };

      // Only include body if it exists (not for GET/DELETE)
      if (body !== undefined) {
        httpRequestOptions.body = body;
      }

      const httpRequest = new HttpRequest(httpRequestOptions);

      // Sign the request
      // uriEscapePath: true is required for paths containing special characters (spaces, colons)
      // It ensures SignatureV4 encodes the path consistently with what API Gateway expects
      const signer = new SignatureV4({
        credentials,
        region,
        service: 'execute-api',
        sha256: Sha256,
        uriEscapePath: true,
      });

      const signedRequest = await signer.sign(httpRequest, {
        signingDate: new Date(),
        signingRegion: region,
        signingService: 'execute-api',
        // Use UNSIGNED-PAYLOAD to avoid CORS issues with x-amz-content-sha256 header
        unsignableHeaders: new Set(['x-amz-content-sha256']),
      });

      // Apply only the required signed headers to axios config
      // We explicitly pick only the headers we need to avoid browser restrictions
      const authHeader = signedRequest.headers['authorization'] || signedRequest.headers['Authorization'];
      const dateHeader = signedRequest.headers['x-amz-date'] || signedRequest.headers['X-Amz-Date'];
      const tokenHeader =
        signedRequest.headers['x-amz-security-token'] || signedRequest.headers['X-Amz-Security-Token'];

      if (authHeader) config.headers.set('authorization', authHeader);
      if (dateHeader) config.headers.set('x-amz-date', dateHeader);
      if (tokenHeader) config.headers.set('x-amz-security-token', tokenHeader);

      return config;
    });

    this.client.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        const response = error.response;
        if (response === undefined) {
          return Promise.reject(error);
        }
        if (response.status === 400) {
          return Promise.reject(new BadRequestError(response.data.message));
        } else if (response.status === 403) {
          return Promise.reject(new UnauthorizedError(response.data.message));
        } else if (response.status === 404) {
          return Promise.reject(new NotFoundError(response.data.message));
        } else if (response.status === 409) {
          return Promise.reject(new ConflictError(response.data.message));
        } else if (response.status >= 500) {
          return Promise.reject(new InternalServerError(response.status, response.data.message));
        } else {
          return Promise.reject(error);
        }
      },
    );
  }

  async getDataByMonth(
    name: CheckAPIName,
    unique_id: string,
    year: number,
    month: number,
  ): Promise<{ [s: string]: any }> {
    const url = urlBuilderGET(name, unique_id, year, month);
    const res = await this.client.get(url);
    return { [name]: res.data.Items };
  }

  async getDataByYear(
    name: CheckAPIName,
    unique_id: string,
    year: number,
    month: number,
  ): Promise<{ [s: string]: any }> {
    const url = urlBuilderGET(name, unique_id, year, month, true);
    const res = await this.client.get(url);
    return { [name]: res.data['Items'] };
  }

  async postData(name: CheckAPIName, unique_id: string, data: { [s: string]: any }): Promise<void> {
    const url = urlBuilderPOST(name, unique_id);
    await this.client.post(url, data, {
      headers: { 'content-type': 'application/json;charset=UTF-8' },
    });
  }

  async putData(
    name: CheckAPIName,
    unique_id: string,
    date: string,
    data: { [s: string]: any },
    change_started_at: boolean,
  ): Promise<void> {
    const url = urlBuilderPUT(name, unique_id, date);
    const queryParametersKey = RecordedAtNamesList.includes(name) ? 'change_recorded_at' : 'change_started_at';

    await this.client.put(url, data, {
      headers: { 'content-type': 'application/json;charset=UTF-8' },
      params: { [queryParametersKey]: change_started_at },
    });
  }

  async swapData(name: CheckAPIName, unique_id: string, data: { [s: string]: any }): Promise<void> {
    const url = urlBuilderSwapPUT(name, unique_id);
    await this.client.put(url, data, {
      headers: { 'content-type': 'application/json;charset=UTF-8' },
    });
  }

  async deleteData(name: CheckAPIName, unique_id: string, date: string): Promise<void> {
    const url = urlBuilderDELETE(name, unique_id, date);
    await this.client.delete(url);
  }

  // 測定1回分の生センサーデータ(CSV)を取得する（moff-trainingcheck-api の /admin/sensor-logs エンドポイント）
  // レスポンスは CSV 本文（text/csv）または署名付き URL（{ url: string }）の両方に対応する
  async getSensorLogCsv(name: CheckAPIName, unique_id: string, started_at: string, data_id?: string): Promise<string> {
    // Do not encode started_at here - URL constructor handles space encoding and SignatureV4 with
    // uriEscapePath: true handles the rest
    const url = `/admin/sensor-logs/${unique_id}/${name}/${started_at}`;
    // data_id は Firehose 行の抽出キー。balance は他種目と形式が異なるため、
    // フロントで組み立てず DynamoDB レコードのパススルー値をそのまま渡す
    const res = await this.client.get(url, data_id ? { params: { data_id } } : undefined);
    if (typeof res.data === 'string') {
      return res.data;
    }
    if (res.data && typeof res.data.url === 'string') {
      const csvRes = await axios.get<string>(res.data.url, {
        responseType: 'text',
        transformResponse: [(data): string => data],
      });
      return csvRes.data;
    }
    throw Error('unexpected sensor log response');
  }

  // ==== データ分析（#113 / API #98 Phase 1）: すべて GET・aws_iam ====

  // フィルタパネルの選択肢（法人・施設・要介護度・性別など、実データ駆動）
  async getAnalyticsFilters(): Promise<{ [s: string]: any }> {
    const res = await this.client.get('/admin/analytics/filters');
    return res.data;
  }

  // 測定一覧の絞り込み検索。filter は URL エンコードした JSON として渡す
  async searchAnalyticsMeasurements(
    filter: { [s: string]: any },
    page = 1,
    perPage = 50,
    sort = '-started_at',
  ): Promise<{ [s: string]: any }> {
    const res = await this.client.get('/admin/analytics/measurements/search', {
      params: { filter: JSON.stringify(filter), page, per_page: perPage, sort },
    });
    return res.data;
  }

  // 分布集計（種目×ビン×最大2軸のクロス集計）
  // バックエンドは { rows, bins, group_by } を返すため rows 配列を取り出す
  async aggregateAnalyticsMeasurements(
    filter: { [s: string]: any },
    bins: number[],
    groupBy: string[],
    dedupe: 'latest' | 'all' = 'latest',
  ): Promise<AggregateRow[]> {
    const res = await this.client.get('/admin/analytics/measurements/aggregate', {
      params: {
        filter: JSON.stringify(filter),
        bins: bins.join(','),
        group_by: groupBy.join(','),
        dedupe,
      },
    });
    return res.data.rows;
  }

  async searchAnalyticsMeasurementsCsv(
    filter: { [s: string]: any },
    page = 1,
    perPage = 500,
    sort = '-started_at',
  ): Promise<string> {
    const res = await this.client.get('/admin/analytics/measurements/search', {
      params: { filter: JSON.stringify(filter), page, per_page: perPage, sort, format: 'csv' },
      responseType: 'text',
      transformResponse: [(data): string => data],
    });
    return res.data;
  }

  async aggregateAnalyticsMeasurementsCsv(
    filter: { [s: string]: any },
    bins: number[],
    groupBy: string[],
    dedupe: 'latest' | 'all' = 'latest',
  ): Promise<string> {
    const res = await this.client.get('/admin/analytics/measurements/aggregate', {
      params: {
        filter: JSON.stringify(filter),
        bins: bins.join(','),
        group_by: groupBy.join(','),
        dedupe,
        format: 'csv',
      },
      responseType: 'text',
      transformResponse: [(data): string => data],
    });
    return res.data;
  }
}
